import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SesionService } from 'src/app/core/service/sesion.service';
import { ContactInformation, UploadFileContactInformation } from './model/potential-customer';
import { ShadowScrollService } from 'src/app/core/service/utils/shadow-scroll.service';
import { DocumentId } from 'src/app/core/model/constans';
import { CustomerInformationService } from './service/customer-information.service';
import { TaxValidation } from '../tax-validation/model/tax-validation';
import { FileUploadService } from '../file-upload/service/file-upload.service';

@Component({
  selector: 'app-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss'],
})
export class ContactInformationComponent implements OnInit {
  files: any[] = [];
  contactForm: FormGroup;
  submitted: boolean;
  loading: boolean;
  sumeTime: number;
  telephoneNumber: string;
  secondaryTelephoneNumber: string;
  secondaryTelephoneIncompleteFields: boolean;
  taxValidationData: TaxValidation | null;
  src: string = 'assets/terms-and-conditions.pdf';
  timeA = {
    start: 6,
    end: 14,
  };
  timeB = {
    start: 14,
    end: 23,
  }
  @Output()
  onComplete = new EventEmitter<number>();

  @Output()
  onBack = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private sesion: SesionService,
    private dialog: MatDialog,
    public shadowScroll: ShadowScrollService,
    private serviceFile: FileUploadService,
    private service: CustomerInformationService,
  ) {
    this.submitted = false;
    this.loading = false;
    this.sumeTime = 0;
    this.telephoneNumber = '';
    this.taxValidationData = this.sesion.getItem('tax_validation');
    this.secondaryTelephoneNumber = '';
    this.secondaryTelephoneIncompleteFields = false;
    this.setFiles();
    this.contactForm = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.pattern(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/), Validators.maxLength(50)],
      ],
      telephoneNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      secondaryTelephoneNumber: ['', Validators.pattern(/^\d{10}$/)],
      timeAStart: [""],
      timeAEnd: [""],
      timeBStart: [""],
      timeBEnd: [""],
      uploadFile0: [''],
    });
  }

  setFiles() {
    this.files = [
      {
        label: 'Fotos del Comercio',
        fileId: 'file 1',
        file: null,
        extensions: ['.png', '.jpeg', '.jpg'],
        size: '20',
        isImg: true,
        documentId: DocumentId.FOTO_COMERCIO,
      },
    ];
  }

  ngOnInit(): void {
    this.contactForm.controls['uploadFile0'].valueChanges.subscribe(() => {
      this.serviceFile.hideSpinner();
    });
    const controlsToWatch = [
      'timeAStart',
      'timeAEnd',
      'timeBStart',
      'timeBEnd'
      ];
  
      controlsToWatch.forEach(controlName => {
        this.contactForm.controls[controlName].valueChanges.subscribe(() => {
          this.onTimeChange();
        });
      });
  }

  back() {
    if (this.taxValidationData?.typePerson == 'F') {
      this.onComplete.emit(4);
    } else {
      this.onBack.emit();
    }
  }

  onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      this.telephoneNumber = this.contactForm.controls['telephoneNumber'].value;
      let timeA = this.subtractTime(
        this.contactForm.controls["timeAEnd"].value,
        this.contactForm.controls["timeAStart"].value
      );
      let timeB = this.subtractTime(
        this.contactForm.controls["timeBEnd"].value,
        this.contactForm.controls["timeBStart"].value
      );
      this.sumeTime = timeA + timeB;
      if (this.contactForm.valid && this.sumeTime >= 4) {
        this.formComplete();
      }
    }
  }

  onTimeChange(){
    let timeA = this.subtractTime(
      this.contactForm.controls["timeAEnd"].value,
      this.contactForm.controls["timeAStart"].value
    );
    let timeB = this.subtractTime(
      this.contactForm.controls["timeBEnd"].value,
      this.contactForm.controls["timeBStart"].value
    );
    this.sumeTime = timeA + timeB;
}

subtractTime(time1: string, time2: string): number {
  // convertir las cadenas de texto en horas y minutos
  const [hours1, minutes1] = time1.split(":").map(Number);
  const [hours2, minutes2] = time2.split(":").map(Number);

  // calcular la diferencia en minutos
  const totalMinutes1 = hours1 * 60 + minutes1;
  const totalMinutes2 = hours2 * 60 + minutes2;
  const diffMinutes = totalMinutes1 - totalMinutes2;

  // convertir la diferencia en horas y minutos
  const hoursDiff = Math.floor(diffMinutes / 60);
  let minutesDiff = diffMinutes % 60;
  if (minutesDiff == 30) {
    minutesDiff = 50;
  }
  let formattedDiff = Number(hoursDiff + "." + minutesDiff);
  return Number.isNaN(formattedDiff) ? 0 : formattedDiff
}

  formattedNumber(number: string): string {
    if (number && number.length === 10) {
      return number.substring(0, 4) + ' ' + number.substring(4);
    }
    return number;
  }

  formComplete() {
    const ContacInformation: ContactInformation = {
      email: this.contactForm.controls['email'].value,
      telephone: this.formattedNumber(this.contactForm.controls['telephoneNumber'].value),
      secondaryTelephone: this.formattedNumber(this.contactForm.controls['secondaryTelephoneNumber'].value),
      timeA: {
        start: this.contactForm.controls["timeAStart"].value,
        end: this.contactForm.controls["timeAEnd"].value,
      },
      timeB: {
        start: this.contactForm.controls["timeBStart"].value,
        end: this.contactForm.controls["timeBEnd"].value,
      },
    };

    const uploadFileOptional: UploadFileContactInformation = {
      uploadFile0: this.contactForm.controls['uploadFile0'].value,
    };
    console.log('contacInfomration', JSON.stringify(ContacInformation.telephone));

    console.log('uploadFile0', uploadFileOptional.uploadFile0);
    this.sesion.setItem('contact-information', JSON.stringify(ContacInformation));
    this.service.saveFiles(uploadFileOptional);
    this.onComplete.emit(7);
  }

  validationPicker(start: any, end: any, touchOne: boolean, touchTwo: boolean) {
    if (start >= end && touchOne && touchTwo) {
      return false;
    }
    return true;
  }

  @HostListener('scroll', ['$event'])
  onScroll(e: any) {
    this.shadowScroll.scroll(e);
  }

  validationLenthTelephone(type: string): boolean {
    let fullnumber;
    let max;
    if (type == 'principal') {
      fullnumber = this.contactForm.controls['telephoneNumber'].value;
      max = 10;
    } else {
      fullnumber = this.contactForm.controls['secondaryTelephoneNumber'].value;
      max = 10;
    }
    return fullnumber.length != max && fullnumber != 0;
  }
}
